import {
    IPagedData,
    IPagedSearch,
    IParticipant,
    IParticipantCreate,
    IParticipantTable,
    TableStatus,
} from '@evencel/models';

export class GetParticipant {
    public static readonly type = '[Participant] GetParticipant';
    constructor(public id: string) {}
}

export class ActivateParticipant {
    public static readonly type = '[Participant] ActivateParticipant';
    constructor(public participant: IParticipantTable) {}
}

export class SearchParticipants {
    public static readonly type = '[Participant] SearchParticipants';
    constructor(public data: IPagedSearch) {}
}

export class CreateParticipant {
    public static readonly type = '[Participant] SaveParticipant';
    constructor(public participant: IParticipantCreate) {}
}

export class UpdateParticipant {
    public static readonly type = '[Participant] UpdateParticipant';
    constructor(public participant: IParticipant) {}
}

export class RestoreParticipant {
    public static readonly type = '[Participant] RestoreParticipant';
    constructor(public participant: IParticipantTable) {}
}

export class GetParticipantsResponse {
    public static readonly type = '[Participant] GetParticipantsResponse';
    constructor(public pagedData: IPagedData<IParticipant>, public status: TableStatus) {}
}

export class GetParticipantResponse {
    public static readonly type = '[Participant] GetParticipantResponse';
    constructor(public participant: IParticipant) {}
}
